var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "multiselect",
        {
          attrs: {
            name: "user_role",
            options: _vm.users,
            placeholder: "Выберите пользователя",
            "track-by": "name",
            label: "name",
            showLabels: false,
            searchable: true,
            multiple: true,
          },
          on: { input: _vm.addUser },
          model: {
            value: _vm.selectedUsers,
            callback: function ($$v) {
              _vm.selectedUsers = $$v
            },
            expression: "selectedUsers",
          },
        },
        [
          _c("template", { slot: "noResult" }, [
            _vm._v("Пользователь не найден"),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", [
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.text,
              expression: "text",
            },
          ],
          staticClass: "form-control mt-1",
          attrs: { rows: "2", placeholder: "Тест сообщения" },
          domProps: { value: _vm.text },
          on: {
            input: function ($event) {
              if ($event.target.composing) return
              _vm.text = $event.target.value
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-right" },
        [
          _c("LoadingButton", {
            attrs: {
              title: "Отправить",
              className: "btn btn-outline-info mt-1",
              onClick: _vm.sendMessage,
              loading: _vm.loading,
              color: _vm.$constants.SUCCESS_COLOR,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "legend" }, [
      _c("p", [_vm._v("К - курьер")]),
      _vm._v(" "),
      _c("p", [_vm._v("СК - старший курьер")]),
      _vm._v(" "),
      _c("p", [_vm._v("М - менеджер")]),
      _vm._v(" "),
      _c("p", [_vm._v("ПМ - помощьник менеджера")]),
      _vm._v(" "),
      _c("p", [_vm._v("S - контролер")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }